import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

const CustomScrollbars = (props) => (
  <Scrollbars
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    autoHide
    renderTrackHorizontal={(props) => (
      <div
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className="track-horizontal"
        style={{ display: 'none' }}
      />
    )}
  />
);

export default CustomScrollbars;
